import React, { useState, useMemo } from "react";
import "~/assets/styles/old-tailwind.css";
import "maplibre-gl/dist/maplibre-gl.css";
import {
  TrackingProvider,
  initializeAnalytics,
} from "@local-logic/core/tracking";
import { LocalLogicProvider } from "~/context/clientProvider";
import { useStateManagerContext } from "~/context/stateManager";
import useIsMobile from "~/hooks/useIsMobile";
import { ProductNames } from "~/types";
import { ANALYTICS_SETTINGS } from "~/constants/analytics";
import { LocalContentProvider } from "./context";
import Map from "./components/Map";
import { LocalContentProps } from "./types";

initializeAnalytics(ANALYTICS_SETTINGS.localContent.key);

const LocalContent = () => {
  const { sdkState } = useStateManagerContext<LocalContentProps>();
  // LocalContent map changes the lat/lng but that's bad for our tracking
  // This will be fixed once we re-do the map of LocalContent
  const [location, _] = useState({
    lat: sdkState.options?.lat,
    lng: sdkState.options?.lng,
  });
  const isMobile = useIsMobile();

  const clientId = useMemo(() => {
    const clientKey = sdkState.apiKey?.split(".") ?? "";

    return clientKey[0].slice(3);
  }, [sdkState.apiKey]);

  return (
    <LocalLogicProvider
      environment={sdkState.globalOptions?.environment?.api}
      apiKey={sdkState.apiKey}
      appearance={sdkState.globalOptions?.appearance}
      locale={sdkState.globalOptions?.locale}
      product={ProductNames.LOCAL_CONTENT}
    >
      <TrackingProvider
        trackingPipelineSettings={{
          apiKey: sdkState.apiKey || "",
        }}
        analyticsSettings={ANALYTICS_SETTINGS.localContent}
        meta={{
          clientId,
          productName: ProductNames.LOCAL_CONTENT,
          productVersion: FULL_APP_VERSION,
        }}
        attributes={{
          location,
          host_url: document.referrer,
          locale: sdkState.globalOptions?.locale,
          isMobile,
          mapProvider: sdkState.options?.mapProvider?.name,
        }}
      >
        <LocalContentProvider>
          <Map />
        </LocalContentProvider>
      </TrackingProvider>
    </LocalLogicProvider>
  );
};

export default LocalContent;
